<template>
  <v-app>
    <div class="app-horizontal-layout">
      <template v-if="!session_ready">
        <preloader></preloader>
      </template>
      <template v-else>
        <forgot-password />
      </template>
    </div>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import Preloader from '@/components/Common/Preloader'
import ForgotPassword from 'Components/Auth/RequestResetPassword'

export default {
  name: 'ForgotPasswordView',
  components: {
    Preloader,
    ForgotPassword,
  },
  computed: {
    ...mapGetters(['routerAnimation', 'session_ready']),
  }
}
</script>

<style scoped>
  .app-horizontal-layout {
    height: 100vh;
  }
</style>
